import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directive from "@/directive";
import {getMonitoAction} from "@/components/monitoAction";

// Vant 组件按需引入
import {
  Button,
  Cell,
  CellGroup,
  Field,
  Form,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  CountDown,
  Toast,
  Dialog,
  Tab,
  Tabs,
  Image,
  Lazyload,
  Popup,
  Loading,
  Overlay,
  ImagePreview
} from 'vant'

// Vant 样式
import 'vant/lib/index.less'

// 全局样式
import './styles/index.less'
getMonitoAction().then(monitoAction => {
  Vue.prototype.$monitoAction = monitoAction;
})
Vue.use(directive);
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Form)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(CountDown)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Image)
Vue.use(Lazyload)
Vue.use(Popup)
Vue.use(Loading)
Vue.use(Overlay)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
